// extracted by mini-css-extract-plugin
module.exports = {"titleInfo":"GenerateCertificado_titleInfo__3rzjq","BackdropStyle":"GenerateCertificado_BackdropStyle__14AZF"};